var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOkButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 236.17 116.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 87.45,
    y1: 58.56,
    x2: 105.17,
    y2: 58.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f8eb30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#28a8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65308f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 58.22,
    x2: 236.17,
    y2: 58.22,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.35,35.94c-3.02,0-5.32.94-6.93,2.81-1.32,1.52-1.97,3.37-1.97,5.56v27.23c0,2.46.63,4.55,1.9,6.29,1.55,2.23,3.89,3.35,7,3.35,3.31,0,5.69-1.12,7.15-3.35,1.12-1.65,1.68-3.84,1.68-6.56v-26.97c0-2.27-.7-4.17-2.11-5.69-1.6-1.78-3.84-2.68-6.71-2.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m214.48,0H21.69C9.71,0,0,8.91,0,19.9v76.65c0,10.99,9.71,19.9,21.69,19.9h192.79c11.98,0,21.69-8.91,21.69-19.9V19.9c0-10.99-9.71-19.9-21.69-19.9Zm-99.17,68.86c-.05,5.71-1.02,10.06-2.92,13.05-2.96,4.55-8.34,6.82-16.12,6.82s-13.27-2.27-16.19-6.82c-1.9-2.9-2.85-7.25-2.85-13.05v-21.48c-.05-5.44.9-9.62,2.85-12.51,2.92-4.46,8.31-6.69,16.19-6.69s13.1,2.23,16.12,6.69c1.94,2.94,2.92,7.11,2.92,12.51v21.48Zm33.33,18.74l-14.08-25.03-3.36,6.42v18.6h-10.07V29.38h10.07v22.42l14.22-22.42h12.33l-17.07,25.03,19.98,33.19h-12.03Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkButton);
export default __webpack_public_path__ + "static/media/ok-button.d1183f706601c318fe40d95cba449434.svg";
export { ForwardRef as ReactComponent };